/* ============================================================
   TRANSLATIONS — EN (default), IT, FR, DE, ES
   ============================================================ */

const translations = {
    /* ── NAVIGATION ── */
    nav: {
        en: { values: 'Our Values', supermath: 'SuperMath', awards: 'Awards', reviews: 'Reviews', teachers: 'Teachers', cta: 'Download App' },
        it: { values: 'I nostri valori', supermath: 'SuperMath', awards: 'Riconoscimenti', reviews: 'Recensioni', teachers: 'Docenti', cta: "Scarica l'App" },
        fr: { values: 'Nos valeurs', supermath: 'SuperMath', awards: 'Distinctions', reviews: 'Avis', teachers: 'Enseignants', cta: "Télécharger l'App" },
        de: { values: 'Unsere Werte', supermath: 'SuperMath', awards: 'Auszeichnungen', reviews: 'Bewertungen', teachers: 'Lehrkräfte', cta: 'App herunterladen' },
        es: { values: 'Nuestros valores', supermath: 'SuperMath', awards: 'Reconocimientos', reviews: 'Reseñas', teachers: 'Docentes', cta: 'Descargar App' },
    },

    /* ── HERO ── */
    hero: {
        en: {
            badge: 'Ethical educational technology',
            titleLine1: 'Technology for learning,',
            titleLine2: 'research for living better.',
            subtitle: 'We develop child-friendly learning systems and innovate to improve quality of life from early childhood.',
            cta1: 'Discover SuperMath',
            cta2: 'Our vision',
        },
        it: {
            badge: 'Tecnologia educativa etica',
            titleLine1: 'Tecnologia per imparare,',
            titleLine2: "ricerca per vivere meglio.",
            subtitle: "Sviluppiamo sistemi di apprendimento a misura di bambino e innoviamo per migliorare la qualità della vita fin dall'infanzia.",
            cta1: 'Scopri SuperMath',
            cta2: 'La nostra visione',
        },
        fr: {
            badge: 'Technologie éducative éthique',
            titleLine1: 'La technologie pour apprendre,',
            titleLine2: "la recherche per mieux vivre.",
            subtitle: "Nous développons des systèmes d'apprentissage à hauteur d'enfant et innovons pour améliorer la qualité de vie dès la petite enfance.",
            cta1: 'Découvrir SuperMath',
            cta2: 'Notre vision',
        },
        de: {
            badge: 'Ethische Bildungstechnologie',
            titleLine1: 'Technologie zum Lernen,',
            titleLine2: 'Forschung für ein besseres Leben.',
            subtitle: 'Wir entwickeln kindgerechte Lernsysteme und setzen Innovationen ein, um die Lebensqualität von Kindheit an zu verbessern.',
            cta1: 'SuperMath entdecken',
            cta2: 'Unsere Vision',
        },
        es: {
            badge: 'Tecnología educativa ética',
            titleLine1: 'Tecnología para aprender,',
            titleLine2: 'investigación para vivir mejor.',
            subtitle: 'Desarrollamos sistemas de aprendizaje a medida del niño e innovamos para mejorar la calidad de vida desde la infancia.',
            cta1: 'Descubre SuperMath',
            cta2: 'Nuestra visión',
        },
    },

    /* ── VALUES ── */
    values: {
        en: {
            label: 'Our values',
            title: 'We build technology with conscience',
            subtitle: 'Learning requires protection and respect. We build digital tools that put student safety at the centre with a transparent model: no ads, no profiling, no tracking of children.',
            privacy: 'Total Privacy',
            privacyDesc: "Students' data is not a commodity. We never profile our users, ensuring a completely safe and transparent environment.",
            ads: 'Zero Ads',
            adsDesc: "No commercial distractions. The student's attention is sacred and exclusively dedicated to learning and growth.",
            ethical: 'Ethical Design',
            ethicalDesc: 'Algorithms designed to stimulate curiosity and learning, never to create screen addiction or manipulate young minds.',
        },
        it: {
            label: 'I nostri valori',
            title: 'Costruiamo tecnologia con coscienza',
            subtitle: "L'apprendimento richiede protezione e rispetto. Costruiamo strumenti digitali che mettono al centro la tutela dello studente con un modello trasparente: niente pubblicità, profilazione o monitoraggio dei bambini.",
            privacy: 'Privacy Totale',
            privacyDesc: 'I dati degli studenti non sono una merce. Non profiliamo mai i nostri utenti, garantendo un ambiente completamente sicuro e trasparente.',
            ads: 'Zero Pubblicità',
            adsDesc: "Nessuna distrazione commerciale. L'attenzione dello studente è sacra e dedicata esclusivamente all'apprendimento e alla crescita.",
            ethical: 'Design Etico',
            ethicalDesc: 'Algoritmi pensati per stimolare la curiosità e l\'apprendimento, mai per creare dipendenza da schermo o manipolare i più giovani.',
        },
        fr: {
            label: 'Nos valeurs',
            title: 'Nous construisons la technologie avec conscience',
            subtitle: "L'apprentissage exige protection et respect. Nous construisons des outils numériques qui placent la protection de l'élève au centre avec un modèle transparent : pas de publicité, pas de profilage, pas de suivi des enfants.",
            privacy: 'Confidentialité totale',
            privacyDesc: "Les données des élèves ne sont pas une marchandise. Nous ne profilons jamais nos utilisateurs, garantissant un environnement totalement sûr et transparent.",
            ads: 'Zéro publicité',
            adsDesc: "Aucune distraction commerciale. L'attention de l'élève est sacrée et exclusivement dédiée à l'apprentissage et à la croissance.",
            ethical: 'Design éthique',
            ethicalDesc: "Des algorithmes conçus pour stimuler la curiosité et l'apprentissage, jamais pour créer une dépendance à l'écran ou manipuler les plus jeunes.",
        },
        de: {
            label: 'Unsere Werte',
            title: 'Wir bauen Technologie mit Gewissen',
            subtitle: 'Lernen erfordert Schutz und Respekt. Wir entwickeln digitale Werkzeuge, die den Schutz der Schüler in den Mittelpunkt stellen — mit einem transparenten Modell: keine Werbung, kein Profiling, kein Tracking von Kindern.',
            privacy: 'Totale Privatsphäre',
            privacyDesc: 'Die Daten der Schüler sind keine Ware. Wir erstellen nie Profile unserer Nutzer und gewährleisten eine vollkommen sichere und transparente Umgebung.',
            ads: 'Keine Werbung',
            adsDesc: 'Keine kommerziellen Ablenkungen. Die Aufmerksamkeit der Schüler ist heilig und ausschließlich dem Lernen und Wachstum gewidmet.',
            ethical: 'Ethisches Design',
            ethicalDesc: 'Algorithmen, die entwickelt wurden, um Neugier und Lernen zu fördern, niemals um Bildschirmsucht zu erzeugen oder junge Menschen zu manipulieren.',
        },
        es: {
            label: 'Nuestros valores',
            title: 'Construimos tecnología con conciencia',
            subtitle: 'El aprendizaje requiere protección y respeto. Construimos herramientas digitales que ponen la protección del estudiante en el centro con un modelo transparente: sin publicidad, sin perfilado, sin rastreo de niños.',
            privacy: 'Privacidad Total',
            privacyDesc: 'Los datos de los estudiantes no son mercancía. Nunca perfilamos a nuestros usuarios, garantizando un entorno completamente seguro y transparente.',
            ads: 'Cero Publicidad',
            adsDesc: 'Sin distracciones comerciales. La atención del estudiante es sagrada y dedicada exclusivamente al aprendizaje y al crecimiento.',
            ethical: 'Diseño Ético',
            ethicalDesc: 'Algoritmos diseñados para estimular la curiosidad y el aprendizaje, nunca para crear adicción a la pantalla o manipular a los más jóvenes.',
        },
    },

    /* ── STORES ── */
    stores: {
        en: {
            appStore: 'Get it on App Store',
            playStore: 'Get it on Google Play'
        },
        it: {
            appStore: 'Scaricalo su App Store',
            playStore: 'Scaricalo su Google Play'
        },
        fr: {
            appStore: "Télécharger sur l’App Store",
            playStore: 'Télécharger sur Google Play'
        },
        de: {
            appStore: 'Im App Store herunterladen',
            playStore: 'Im Google Play Store herunterladen'
        },
        es: {
            appStore: 'Descargar en la App Store',
            playStore: 'Descargar en Google Play'
        },
    },

    /* ── SUPERMATH ── */
    supermath: {
        en: {
            badge: 'Our flagship product',
            desc: "The evolution of Mathematical Run. A math adventure that turns mental calculation into an exciting game, from kindergarten to middle school. Loved by thousands of students worldwide.",
            rating: '4.6 on the App Stores',
            learnMore: 'Learn more',
        },
        it: {
            badge: 'Il nostro prodotto principale',
            desc: "L'evoluzione di Mathematical Run. Un'avventura matematica che trasforma il calcolo mentale in un gioco avvincente, dalla scuola dell'infanzia alle medie. Amata da migliaia di studenti in tutto il mondo.",
            rating: '4.6 sugli App Stores',
            learnMore: 'Scopri di più',
        },
        fr: {
            badge: 'Notre produit phare',
            desc: "L'évolution de Mathematical Run. Une aventure mathématique qui transforme le calcul mental en un jeu passionnant, de la maternelle au collège. Adorée par des milliers d'élèves dans le monde entier.",
            rating: '4.6 sur les App Stores',
            learnMore: 'En savoir plus',
        },
        de: {
            badge: 'Unser Hauptprodukt',
            desc: 'Die Weiterentwicklung von Mathematical Run. Ein Mathe-Abenteuer, das Kopfrechnen in ein spannendes Spiel verwandelt, vom Kindergarten bis zur Mittelstufe. Geliebt von Tausenden von Schülern weltweit.',
            rating: '4.6 in den App Stores',
            learnMore: 'Mehr erfahren',
        },
        es: {
            badge: 'Nuestro producto principal',
            desc: 'La evolución de Mathematical Run. Una aventura matemática que transforma el cálculo mental en un juego emocionante, desde preescolar hasta la secundaria. Amada por miles de estudiantes en todo el mundo.',
            rating: '4.6 en las App Stores',
            learnMore: 'Saber más',
        },
    },

    /* ── SUPERMATH TEACHER ── */
    supermathTeacher: {
        en: {
            badge: 'For teachers',
            title: 'SuperMath Teacher',
            subtitle: 'The complete math platform for primary and middle school teachers',
            desc: 'SuperMath Teacher turns homework and assessment into a simple, inclusive experience. Create custom assignments — including tasks tailored for students with SEN/SLD — while every student uses the same tool, in class and at home. No stigma, no separation.',
            f1: 'Create personalised assignments for the whole class',
            f2: 'Tailored tasks for SEN/SLD students using the same app',
            f3: 'Track progress and identify areas for improvement',
            f4: 'Usable in class and at home as study support',
            f5: 'Seamless integration with SuperMath for students',
            appStoreUrl: 'https://apps.apple.com/us/app/supermath-teacher-classe-lim/id6751410021',
            playStoreUrl: 'https://play.google.com/store/apps/details?id=com.eagletap.mathematicalrunforteacher',
            inclusive: 'Inclusive by design',
            inclusiveDesc: 'All students use the same app. Teachers can customise difficulty for individual needs without isolating anyone.',
        },
        it: {
            badge: 'Per i docenti',
            title: 'SuperMath Teacher',
            subtitle: 'La piattaforma di matematica completa per insegnanti di scuola primaria e secondaria di primo grado',
            desc: 'SuperMath Teacher trasforma i compiti e le verifiche in un\'esperienza semplice e inclusiva. Crea compiti personalizzati — anche attività specifiche per studenti con DSA/BES — mentre tutti gli studenti usano lo stesso strumento, sia in classe che a casa. Nessuno stigma, nessuna separazione.',
            f1: 'Crea compiti personalizzati per tutta la classe',
            f2: 'Attività su misura per studenti DSA/BES con la stessa app',
            f3: 'Monitora i progressi e individua le aree di miglioramento',
            f4: 'Utilizzabile in classe e a casa come supporto allo studio',
            f5: 'Integrazione perfetta con SuperMath per gli studenti',
            appStoreUrl: 'https://apps.apple.com/it/app/supermath-teacher-classe-lim/id6751410021',
            playStoreUrl: 'https://play.google.com/store/apps/details?id=com.eagletap.mathematicalrunforteacher',
            inclusive: 'Inclusivo per design',
            inclusiveDesc: 'Tutti gli studenti usano la stessa app. Gli insegnanti possono personalizzare la difficoltà per le esigenze individuali senza isolare nessuno.',
        },
        fr: {
            badge: 'Pour les enseignants',
            title: 'SuperMath Teacher',
            subtitle: 'La plateforme mathématique complète pour les enseignants du primaire et du collège',
            desc: 'SuperMath Teacher transforme les devoirs et les évaluations en une expérience simple et inclusive. Créez des exercices personnalisés — y compris des activités adaptées aux élèves avec des besoins éducatifs particuliers — tandis que tous les élèves utilisent le même outil, en classe et à la maison. Aucune stigmatisation, aucune séparation.',
            f1: 'Créez des exercices personnalisés pour toute la classe',
            f2: 'Activités adaptées pour les élèves à besoins particuliers avec la même app',
            f3: 'Suivez les progrès et identifiez les axes d\'amélioration',
            f4: 'Utilisable en classe et à la maison comme soutien scolaire',
            f5: 'Intégration parfaite avec SuperMath pour les élèves',
            appStoreUrl: 'https://apps.apple.com/fr/app/supermath-teacher-classe-lim/id6751410021',
            playStoreUrl: 'https://play.google.com/store/apps/details?id=com.eagletap.mathematicalrunforteacher',
            inclusive: 'Inclusif par conception',
            inclusiveDesc: 'Tous les élèves utilisent la même app. Les enseignants peuvent personnaliser la difficulté selon les besoins individuels sans isoler personne.',
        },
        de: {
            badge: 'Für Lehrkräfte',
            title: 'SuperMath Teacher',
            subtitle: 'Die komplette Mathe-Plattform für Lehrkräfte der Grundschule und Sekundarstufe I',
            desc: 'SuperMath Teacher verwandelt Hausaufgaben und Prüfungen in ein einfaches, inklusives Erlebnis. Erstellen Sie individuelle Aufgaben — auch speziell für Schüler mit Förderbedarf — während alle Schüler dasselbe Werkzeug nutzen, im Unterricht und zu Hause. Keine Stigmatisierung, keine Trennung.',
            f1: 'Erstellen Sie individuelle Aufgaben für die gesamte Klasse',
            f2: 'Angepasste Aufgaben für Schüler mit Förderbedarf mit derselben App',
            f3: 'Verfolgen Sie Fortschritte und identifizieren Sie Verbesserungsbereiche',
            f4: 'Nutzbar im Unterricht und zu Hause als Lernunterstützung',
            f5: 'Nahtlose Integration mit SuperMath für Schüler',
            appStoreUrl: 'https://apps.apple.com/de/app/supermath-teacher-classe-lim/id6751410021',
            playStoreUrl: 'https://play.google.com/store/apps/details?id=com.eagletap.mathematicalrunforteacher',
            inclusive: 'Inklusiv gestaltet',
            inclusiveDesc: 'Alle Schüler nutzen dieselbe App. Lehrkräfte können die Schwierigkeit individuell anpassen, ohne jemanden auszugrenzen.',
        },
        es: {
            badge: 'Para docentes',
            title: 'SuperMath Teacher',
            subtitle: 'La plataforma matemática completa para docentes de primaria y secundaria',
            desc: 'SuperMath Teacher transforma los deberes y las evaluaciones en una experiencia simple e inclusiva. Crea tareas personalizadas — incluyendo actividades específicas para estudiantes con necesidades educativas especiales — mientras todos los estudiantes usan la misma herramienta, en clase y en casa. Sin estigma, sin separación.',
            f1: 'Crea tareas personalizadas para toda la clase',
            f2: 'Actividades adaptadas para estudiantes con NEE usando la misma app',
            f3: 'Monitorea el progreso e identifica las áreas de mejora',
            f4: 'Utilizable en clase y en casa como apoyo al estudio',
            f5: 'Integración perfecta con SuperMath para los estudiantes',
            appStoreUrl: 'https://apps.apple.com/es/app/supermath-teacher-classe-lim/id6751410021',
            playStoreUrl: 'https://play.google.com/store/apps/details?id=com.eagletap.mathematicalrunforteacher',
            inclusive: 'Inclusivo por diseño',
            inclusiveDesc: 'Todos los estudiantes usan la misma app. Los docentes pueden personalizar la dificultad según las necesidades individuales sin aislar a nadie.',
        },
    },

    /* ── LEONORA'S COLORS ── */
    leonora: {
        en: {
            badge: 'For little ones',
            title: "Leonora's Colors",
            subtitle: 'Learn primary and secondary colours by playing',
            desc: "A colourful adventure designed for preschoolers. Children discover primary and secondary colours through interactive mixing, fun experiments, and playful challenges — all in a safe, ad-free environment.",
            f1: 'Learn primary colours: red, yellow, blue',
            f2: 'Discover how to mix colours to create new ones',
            f3: 'Engaging visual experiments for little hands',
            f4: 'No ads, no in-app purchases — completely safe',
            appStoreUrl: 'https://apps.apple.com/us/app/leonoras-colors/id1406175989',
            playStoreUrl: 'https://play.google.com/store/apps/details?id=com.eagletap.leonorascolors',
        },
        it: {
            badge: 'Per i più piccoli',
            title: "Leonora's Colors",
            subtitle: 'Impara i colori primari e secondari giocando',
            desc: "Un'avventura colorata pensata per i bambini in età prescolare. I piccoli scoprono i colori primari e secondari attraverso miscelazioni interattive, esperimenti divertenti e sfide giocose — il tutto in un ambiente sicuro e senza pubblicità.",
            f1: 'Impara i colori primari: rosso, giallo, blu',
            f2: 'Scopri come mescolare i colori per crearne di nuovi',
            f3: 'Esperimenti visivi coinvolgenti per le piccole mani',
            f4: 'Nessuna pubblicità, nessun acquisto in-app — completamente sicuro',
            appStoreUrl: 'https://apps.apple.com/it/app/leonoras-colors/id1406175989',
            playStoreUrl: 'https://play.google.com/store/apps/details?id=com.eagletap.leonorascolors',
        },
        fr: {
            badge: 'Pour les tout-petits',
            title: "Leonora's Colors",
            subtitle: 'Apprends les couleurs primaires et secondaires en jouant',
            desc: "Une aventure colorée conçue pour les enfants d'âge préscolaire. Les petits découvrent les couleurs primaires et secondaires à travers des mélanges interactifs, des expériences amusantes et des défis ludiques — le tout dans un environnement sûr et sans publicité.",
            f1: 'Apprends les couleurs primaires : rouge, jaune, bleu',
            f2: 'Découvre comment mélanger les couleurs pour en créer de nouvelles',
            f3: 'Des expériences visuelles captivantes pour les petites mains',
            f4: 'Pas de publicité, pas d\'achats intégrés — totalement sûr',
            appStoreUrl: 'https://apps.apple.com/fr/app/leonoras-colors/id1406175989',
            playStoreUrl: 'https://play.google.com/store/apps/details?id=com.eagletap.leonorascolors',
        },
        de: {
            badge: 'Für die Kleinsten',
            title: "Leonora's Colors",
            subtitle: 'Lerne Primär- und Sekundärfarben spielerisch',
            desc: 'Ein farbenfrohes Abenteuer für Vorschulkinder. Kinder entdecken Primär- und Sekundärfarben durch interaktives Mischen, lustige Experimente und spielerische Herausforderungen — alles in einer sicheren, werbefreien Umgebung.',
            f1: 'Lerne Grundfarben: Rot, Gelb, Blau',
            f2: 'Entdecke, wie man Farben mischt, um neue zu erschaffen',
            f3: 'Spannende visuelle Experimente für kleine Hände',
            f4: 'Keine Werbung, keine In-App-Käufe — vollkommen sicher',
            appStoreUrl: 'https://apps.apple.com/de/app/leonoras-colors/id1406175989',
            playStoreUrl: 'https://play.google.com/store/apps/details?id=com.eagletap.leonorascolors',
        },
        es: {
            badge: 'Para los más pequeños',
            title: "Leonora's Colors",
            subtitle: 'Aprende colores primarios y secundarios jugando',
            desc: 'Una aventura colorida diseñada para niños en edad preescolar. Los pequeños descubren colores primarios y secundarios a través de mezclas interactivas, experimentos divertidos y desafíos lúdicos — todo en un entorno seguro y sin publicidad.',
            f1: 'Aprende colores primarios: rojo, amarillo, azul',
            f2: 'Descubre cómo mezclar colores para crear nuevos',
            f3: 'Experimentos visuales atractivos para las manitas',
            f4: 'Sin publicidad, sin compras integradas — completamente seguro',
            appStoreUrl: 'https://apps.apple.com/es/app/leonoras-colors/id1406175989',
            playStoreUrl: 'https://play.google.com/store/apps/details?id=com.eagletap.leonorascolors',
        },
    },

    /* ── RESEARCH & DEVELOPMENT ── */
    rnd: {
        en: {
            badge: 'Research & Development',
            title: 'Beyond studying:',
            subtitle: 'cognitive health.',
            desc: 'Technology can make the difference between an overlooked difficulty and a path to success. We are developing, in collaboration with Italian schools, an intelligent screening system for early diagnosis of dyscalculia. The goal is to identify cognitive patterns quickly, anonymously, and with scientific accuracy to enable targeted interventions that improve students\' lives.',
            f1: 'Intelligent screening for early dyscalculia diagnosis',
            f2: 'Developed in collaboration with schools',
            f3: 'Rapid, anonymous, and scientifically accurate detection',
            f4: 'Targeted interventions to improve students\' lives',
        },
        it: {
            badge: 'Ricerca e sviluppo',
            title: 'Oltre lo studio:',
            subtitle: 'la salute cognitiva.',
            desc: "La tecnologia può fare la differenza tra una difficoltà trascurata e un percorso di successo. Stiamo sviluppando, in collaborazione con alcune scuole italiane, un sistema di screening intelligente per la diagnosi precoce della discalculia. L'obiettivo è identificare i pattern cognitivi in modo rapido, anonimo e scientificamente accurato per permettere interventi mirati che migliorano la vita degli studenti.",
            f1: 'Screening intelligente per la diagnosi precoce della discalculia',
            f2: 'Sviluppato in collaborazione con le scuole',
            f3: 'Rilevamento rapido, anonimo e scientificamente accurato',
            f4: 'Interventi mirati per migliorare la vita degli studenti',
        },
        fr: {
            badge: 'Recherche et développement',
            title: 'Au-delà des études :',
            subtitle: 'la santé cognitive.',
            desc: "La technologie peut faire la différence entre une difficulté négligée et un parcours de réussite. Nous développons, en collaboration avec des écoles italiennes, un système de dépistage intelligent pour le diagnostic précoce de la dyscalculie. L'objectif est d'identifier les schémas cognitifs de manière rapide, anonyme et scientifiquement précise pour permettre des interventions ciblées qui améliorent la vie des élèves.",
            f1: 'Dépistage intelligent pour le diagnostic précoce de la dyscalculie',
            f2: 'Développé en collaboration avec des écoles',
            f3: 'Détection rapide, anonyme et scientifiquement précise',
            f4: 'Interventions ciblées pour améliorer la vie des élèves',
        },
        de: {
            badge: 'Forschung & Entwicklung',
            title: 'Über das Lernen hinaus:',
            subtitle: 'kognitive Gesundheit.',
            desc: 'Technologie kann den Unterschied zwischen einer übersehenen Schwierigkeit und einem erfolgreichen Weg ausmachen. Wir entwickeln in Zusammenarbeit mit italienischen Schulen ein intelligentes Screening-System zur Früherkennung von Dyskalkulie. Ziel ist es, kognitive Muster schnell, anonym und wissenschaftlich präzise zu identifizieren, um gezielte Interventionen zu ermöglichen, die das Leben der Schüler verbessern.',
            f1: 'Intelligentes Screening zur Früherkennung von Dyskalkulie',
            f2: 'Entwickelt in Zusammenarbeit mit Schulen',
            f3: 'Schnelle, anonyme und wissenschaftlich genaue Erkennung',
            f4: 'Gezielte Interventionen zur Verbesserung des Lebens der Schüler',
        },
        es: {
            badge: 'Investigación y desarrollo',
            title: 'Más allá del estudio:',
            subtitle: 'la salud cognitiva.',
            desc: 'La tecnología puede marcar la diferencia entre una dificultad ignorada y un camino hacia el éxito. Estamos desarrollando, en colaboración con escuelas italianas, un sistema de cribado inteligente para el diagnóstico precoz de la discalculia. El objetivo es identificar patrones cognitivos de forma rápida, anónima y científicamente precisa para permitir intervenciones específicas que mejoren la vida de los estudiantes.',
            f1: 'Cribado inteligente para el diagnóstico precoz de la discalculia',
            f2: 'Desarrollado en colaboración con escuelas',
            f3: 'Detección rápida, anónima y científicamente precisa',
            f4: 'Intervenciones específicas para mejorar la vida de los estudiantes',
        },
    },

    /* ── AWARDS (Premio Cambiamenti 2026) ── */
    awards: {
        en: {
            badge: 'Awards',
            title: '2nd Place at Premio Cambiamenti 2026',
            subtitle: 'Siracusa Regional Final',
            desc: 'We are proud to announce that EagleTap placed 2nd in the regional final of the Premio Cambiamenti 2026 CNA competition, held in Siracusa, also receiving a special mention for Social Impact.',
            desc2: 'A recognition that confirms our vision: to create ethical, accessible educational technology with real impact for kids, families and schools.',
            card1Title: '2nd Place',
            card1Sub: 'CNA Regional Final',
            card2Title: 'Social Impact',
            card2Sub: 'Special Mention',
            img1Alt: 'Premio Cambiamenti 2026 award ceremony in Siracusa',
            img2Alt: 'Premio Cambiamenti 2026 award ceremony in Siracusa — Social Impact award',
        },
        it: {
            badge: 'Riconoscimenti',
            title: '2° Posto al Premio Cambiamenti 2026',
            subtitle: 'Finale Regionale Siracusa',
            desc: "Siamo orgogliosi di annunciare che EagleTap si è classificata al 2° posto nella finale regionale del Premio Cambiamenti 2026 CNA svoltasi a Siracusa, ricevendo anche la menzione speciale per l'Impatto Sociale.",
            desc2: 'Un riconoscimento che conferma la bontà della nostra visione: creare tecnologia educativa etica, accessibile e ad alto impatto per ragazzi, famiglie e scuole.',
            card1Title: '2° Classificato',
            card1Sub: 'Finale Regionale CNA',
            card2Title: 'Impatto Sociale',
            card2Sub: 'Menzione Speciale',
            img1Alt: 'Premiazione Premio Cambiamenti 2026 Siracusa',
            img2Alt: 'Premiazione Premio Cambiamenti 2026 Siracusa — Impatto Sociale',
        },
        fr: {
            badge: 'Distinctions',
            title: 'Deuxième place au Premio Cambiamenti 2026',
            subtitle: 'Finale régionale de Syracuse',
            desc: "Nous sommes fiers d'annoncer qu'EagleTap s'est classée 2e à la finale régionale du Premio Cambiamenti 2026 CNA, qui s'est tenue à Syracuse, recevant également une mention spéciale pour l'Impact Social.",
            desc2: 'Une reconnaissance qui confirme la justesse de notre vision : créer une technologie éducative éthique, accessible et à fort impact pour les enfants, les familles et les écoles.',
            card1Title: '2e classé',
            card1Sub: 'Finale régionale CNA',
            card2Title: 'Impact Social',
            card2Sub: 'Mention spéciale',
            img1Alt: 'Cérémonie de remise du Premio Cambiamenti 2026 à Syracuse',
            img2Alt: 'Cérémonie de remise du Premio Cambiamenti 2026 à Syracuse — prix Impact Social',
        },
        de: {
            badge: 'Auszeichnungen',
            title: '2. Platz beim Premio Cambiamenti 2026',
            subtitle: 'Regionalfinale Syrakus',
            desc: 'Wir freuen uns, bekannt zu geben, dass EagleTap beim Regionalfinale des Premio Cambiamenti 2026 CNA in Syrakus den 2. Platz belegt hat und zusätzlich die besondere Anerkennung für sozialen Einfluss erhielt.',
            desc2: 'Eine Auszeichnung, die unsere Vision bestätigt: ethische, zugängliche Bildungstechnologie mit hoher Wirkung für Kinder, Familien und Schulen zu schaffen.',
            card1Title: '2. Platz',
            card1Sub: 'CNA-Regionalfinale',
            card2Title: 'Sozialer Einfluss',
            card2Sub: 'Besondere Anerkennung',
            img1Alt: 'Preisverleihung Premio Cambiamenti 2026 in Syrakus',
            img2Alt: 'Preisverleihung Premio Cambiamenti 2026 in Syrakus — Auszeichnung für sozialen Einfluss',
        },
        es: {
            badge: 'Reconocimientos',
            title: '2º Puesto en el Premio Cambiamenti 2026',
            subtitle: 'Final Regional de Siracusa',
            desc: 'Nos enorgullece anunciar que EagleTap quedó en 2º lugar en la final regional del Premio Cambiamenti 2026 CNA, celebrada en Siracusa, recibiendo también la mención especial de Impacto Social.',
            desc2: 'Un reconocimiento que confirma la validez de nuestra visión: crear tecnología educativa ética, accesible y de alto impacto para niños, familias y escuelas.',
            card1Title: '2º Clasificado',
            card1Sub: 'Final Regional CNA',
            card2Title: 'Impacto Social',
            card2Sub: 'Mención Especial',
            img1Alt: 'Ceremonia de premiación del Premio Cambiamenti 2026 en Siracusa',
            img2Alt: 'Ceremonia de premiación del Premio Cambiamenti 2026 en Siracusa — premio Impacto Social',
        },
    },

    /* ── REVIEWS ── */
    reviews: {
        en: {
            label: 'Reviews',
            title: 'What our users say',
            subtitle: 'Our users\' Store reviews speak for themselves.',
            r1: "I miei bimbi più che entusiasti...magari facessero sempre i compiti con lo stesso entusiasmo con cui fanno questo gioco.",
            a1: 'Genitore',
            r2: "Ottimi giochi di matematica di vari livelli, buoni come esercizi per rimandare in allenamento con la matematica.",
            a2: 'Utente',
            r3: "Finalmente un gioco costruttivo che ti permette di giocare ma allo stesso tempo di imparare qualcosa. Veramente bello.",
            a3: 'Utente',
        },
        it: {
            label: 'Recensioni',
            title: 'Cosa dicono gli utenti',
            subtitle: "Le recensioni dei nostri utenti sugli App Store parlano chiaro.",
            r1: "I miei bimbi più che entusiasti...magari facessero sempre i compiti con lo stesso entusiasmo con cui fanno questo gioco.",
            a1: 'Genitore',
            r2: "Ottimi giochi di matematica di vari livelli, buoni come esercizi per rimandare in allenamento con la matematica.",
            a2: 'Utente',
            r3: "Finalmente un gioco costruttivo che ti permette di giocare ma allo stesso tempo di imparare qualcosa. Veramente bello.",
            a3: 'Utente',
        },
        fr: {
            label: 'Avis',
            title: 'Ce que disent nos utilisateurs',
            subtitle: "Les avis de nos utilisateurs sur les Stores parlent d'eux-mêmes.",
            r1: "I miei bimbi più che entusiasti...magari facessero sempre i compiti con lo stesso entusiasmo con cui fanno questo gioco.",
            a1: 'Genitore',
            r2: "Ottimi giochi di matematica di vari livelli, buoni come esercizi per rimandare in allenamento con la matematica.",
            a2: 'Utente',
            r3: "Finalmente un gioco costruttivo che ti permette di giocare ma allo stesso tempo di imparare qualcosa. Veramente bello.",
            a3: 'Utente',
        },
        de: {
            label: 'Bewertungen',
            title: 'Was unsere Nutzer sagen',
            subtitle: 'Die Store-Bewertungen unserer Nutzer sprechen für sich.',
            r1: "I miei bimbi più che entusiasti...magari facessero sempre i compiti con lo stesso entusiasmo con cui fanno questo gioco.",
            a1: 'Genitore',
            r2: "Ottimi giochi di matematica di vari livelli, buoni come esercizi per rimandare in allenamento con la matematica.",
            a2: 'Utente',
            r3: "Finalmente un gioco costruttivo che ti permette di giocare ma allo stesso tempo di imparare qualcosa. Veramente bello.",
            a3: 'Utente',
        },
        es: {
            label: 'Reseñas',
            title: 'Lo que dicen nuestros usuarios',
            subtitle: 'Las reseñas de nuestros usuarios en las Stores hablan por sí solas.',
            r1: "I miei bimbi più che entusiasti...magari facessero sempre i compiti con lo stesso entusiasmo con cui fanno questo gioco.",
            a1: 'Genitore',
            r2: "Ottimi giochi di matematica di vari livelli, buoni come esercizi per rimandare in allenamento con la matematica.",
            a2: 'Utente',
            r3: "Finalmente un gioco costruttivo che ti permette di giocare ma allo stesso tempo di imparare qualcosa. Veramente bello.",
            a3: 'Utente',
        },
    },

    /* ── TEACHERS ── */
    teachers: {
        en: {
            label: 'Coming soon',
            titleLine1: 'A platform',
            titleLine2: 'built for teachers',
            desc: "We're building a dashboard dedicated to teachers. Monitor class progress, assign personalised challenges, and analyse areas for improvement — always with full respect for individual privacy.",
            f1: 'Dashboard with class progress overview',
            f2: 'Assignment of personalised challenges and tasks',
            f3: 'Analysis of strengths and areas for improvement',
            f4: 'No student personal data exposed',
            formTitle: 'Are you a teacher?',
            formSubtitle: 'Join the waiting list to get early access to the teachers platform.',
            placeholderName: 'Full Name',
            placeholderEmail: 'email@school.com',
            placeholderSchool: 'School name (optional)',
            submit: 'Join the Waitlist',
            privacy: 'We will never share your data with third parties.',
        },
        it: {
            label: 'In arrivo',
            titleLine1: 'Una piattaforma',
            titleLine2: 'pensata per i docenti',
            desc: 'Stiamo costruendo una dashboard dedicata agli insegnanti. Monitora i progressi della classe, assegna sfide personalizzate e analizza le aree di miglioramento — sempre nel pieno rispetto della privacy individuale.',
            f1: 'Dashboard con panoramica progressi della classe',
            f2: 'Assegnazione di sfide e compiti personalizzati',
            f3: 'Analisi delle aree di forza e miglioramento',
            f4: 'Nessun dato personale dello studente esposto',
            formTitle: 'Sei un insegnante?',
            formSubtitle: "Entra nella lista d'attesa per accedere in anteprima alla piattaforma docenti.",
            placeholderName: 'Nome e Cognome',
            placeholderEmail: 'email@scuola.it',
            placeholderSchool: 'Nome della scuola (opzionale)',
            submit: 'Unisciti alla Waitlist',
            privacy: 'Non condivideremo mai i tuoi dati con terzi.',
        },
        fr: {
            label: 'Bientôt disponible',
            titleLine1: 'Une plateforme',
            titleLine2: 'conçue pour les enseignants',
            desc: "Nous construisons un tableau de bord dédié aux enseignants. Suivez les progrès de la classe, assignez des défis personnalisés et analysez les axes d'amélioration — toujours dans le respect total de la vie privée individuelle.",
            f1: 'Tableau de bord avec vue des progrès de la classe',
            f2: 'Attribution de défis et devoirs personnalisés',
            f3: "Analyse des points forts et axes d'amélioration",
            f4: 'Aucune donnée personnelle des élèves exposée',
            formTitle: 'Vous êtes enseignant(e) ?',
            formSubtitle: "Inscrivez-vous sur la liste d'attente pour accéder en avant-première à la plateforme enseignants.",
            placeholderName: 'Nom et prénom',
            placeholderEmail: 'email@ecole.fr',
            placeholderSchool: "Nom de l'école (optionnel)",
            submit: "Rejoindre la liste d'attente",
            privacy: 'Nous ne partagerons jamais vos données avec des tiers.',
        },
        de: {
            label: 'Demnächst verfügbar',
            titleLine1: 'Eine Plattform',
            titleLine2: 'für Lehrkräfte entwickelt',
            desc: 'Wir bauen ein Dashboard speziell für Lehrkräfte. Verfolgen Sie den Fortschritt der Klasse, vergeben Sie individuelle Herausforderungen und analysieren Sie Verbesserungsbereiche — immer unter vollem Schutz der individuellen Privatsphäre.',
            f1: 'Dashboard mit Klassenfortschritts-Übersicht',
            f2: 'Zuweisung individueller Herausforderungen und Aufgaben',
            f3: 'Analyse von Stärken und Verbesserungsbereichen',
            f4: 'Keine persönlichen Schülerdaten offengelegt',
            formTitle: 'Sind Sie Lehrkraft?',
            formSubtitle: 'Tragen Sie sich in die Warteliste ein, um frühzeitig Zugang zur Lehrkräfte-Plattform zu erhalten.',
            placeholderName: 'Vollständiger Name',
            placeholderEmail: 'email@schule.de',
            placeholderSchool: 'Schulname (optional)',
            submit: 'Auf die Warteliste',
            privacy: 'Wir werden Ihre Daten niemals an Dritte weitergeben.',
        },
        es: {
            label: 'Próximamente',
            titleLine1: 'Una plataforma',
            titleLine2: 'pensada para docentes',
            desc: 'Estamos construyendo un panel dedicado a los docentes. Monitorea el progreso de la clase, asigna desafíos personalizados y analiza las áreas de mejora — siempre respetando la privacidad individual.',
            f1: 'Panel con vista general del progreso de la clase',
            f2: 'Asignación de desafíos y tareas personalizados',
            f3: 'Análisis de fortalezas y áreas de mejora',
            f4: 'Ningún dato personal del estudiante expuesto',
            formTitle: '¿Eres docente?',
            formSubtitle: 'Únete a la lista de espera para acceder en primicia a la plataforma para docentes.',
            placeholderName: 'Nombre completo',
            placeholderEmail: 'email@escuela.es',
            placeholderSchool: 'Nombre de la escuela (opcional)',
            submit: 'Únete a la Waitlist',
            privacy: 'Nunca compartiremos tus datos con terceros.',
        },
    },

    /* ── FOOTER ── */
    footer: {
        en: {
            desc: 'Ethical educational technology for students, teachers, and families. Research for living better.',
            products: 'Products',
            teachersPlatform: 'Teachers Platform',
            company: 'Company',
            ourValues: 'Our values',
            reviewsLink: 'Reviews',
            contact: 'Contact us',
            legal: 'Legal',
            privacyPolicy: 'Apps Privacy Policy',
            terms: 'Apps Terms of Service',
            sitePrivacy: 'Privacy Policy',
            siteTerms: 'Terms of Service',
            copyright: 'All rights reserved.',
        },
        it: {
            desc: 'Tecnologia educativa etica per studenti, insegnanti e famiglie. Ricerca per vivere meglio.',
            products: 'Prodotti',
            teachersPlatform: 'Piattaforma Docenti',
            company: 'Azienda',
            ourValues: 'I nostri valori',
            reviewsLink: 'Recensioni',
            contact: 'Contattaci',
            legal: 'Legale',
            privacyPolicy: 'Privacy Policy delle App',
            terms: 'Termini di Servizio delle App',
            sitePrivacy: 'Privacy Policy',
            siteTerms: 'Termini di Servizio',
            copyright: 'Tutti i diritti riservati.',
        },
        fr: {
            desc: "Technologie éducative éthique pour les élèves, les enseignants et les familles. La recherche pour mieux vivre.",
            products: 'Produits',
            teachersPlatform: 'Plateforme Enseignants',
            company: 'Entreprise',
            ourValues: 'Nos valeurs',
            reviewsLink: 'Avis',
            contact: 'Nous contacter',
            legal: 'Mentions légales',
            privacyPolicy: 'Politique de confidentialité des Apps',
            terms: "Conditions d'utilisation des Apps",
            sitePrivacy: 'Politique de confidentialité',
            siteTerms: "Conditions d'utilisation",
            copyright: 'Tous droits réservés.',
        },
        de: {
            desc: 'Ethische Bildungstechnologie für Schüler, Lehrer und Familien. Forschung für ein besseres Leben.',
            products: 'Produkte',
            teachersPlatform: 'Lehrkräfte-Plattform',
            company: 'Unternehmen',
            ourValues: 'Unsere Werte',
            reviewsLink: 'Bewertungen',
            contact: 'Kontakt',
            legal: 'Rechtliches',
            privacyPolicy: 'Datenschutzrichtlinie der Apps',
            terms: 'Nutzungsbedingungen der Apps',
            sitePrivacy: 'Datenschutzrichtlinie',
            siteTerms: 'Nutzungsbedingungen',
            copyright: 'Alle Rechte vorbehalten.',
        },
        es: {
            desc: 'Tecnología educativa ética para estudiantes, profesores y familias. Investigación para vivir mejor.',
            products: 'Productos',
            teachersPlatform: 'Plataforma Docentes',
            company: 'Empresa',
            ourValues: 'Nuestros valores',
            reviewsLink: 'Reseñas',
            contact: 'Contáctanos',
            legal: 'Legal',
            privacyPolicy: 'Política de Privacidad de las Apps',
            terms: 'Términos de Servicio de las Apps',
            sitePrivacy: 'Política de Privacidad',
            siteTerms: 'Términos de Servicio',
            copyright: 'Todos los derechos reservados.',
        },
    },
};

/* Helper: get a section for a given language */
export const t = (section, lang) => translations[section]?.[lang] || translations[section]?.en || {};

export const LANGUAGES = [
    { code: 'en', flag: '🇬🇧', name: 'English' },
    { code: 'it', flag: '🇮🇹', name: 'Italiano' },
    { code: 'fr', flag: '🇫🇷', name: 'Français' },
    { code: 'de', flag: '🇩🇪', name: 'Deutsch' },
    { code: 'es', flag: '🇪🇸', name: 'Español' },
];

export default translations;
